import { Component, inject, Input, OnInit } from '@angular/core';
import { LabelComponent } from '@progress/kendo-angular-label';
import { TranslatePipe } from '@ngx-translate/core';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@progress/kendo-angular-inputs';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: 'app-discount-card-selection',
    imports: [
        LabelComponent,
        TranslatePipe,
        DropDownListComponent,
        ReactiveFormsModule,
        FormFieldComponent,
    ],
    templateUrl: './discount-card-selection.component.html',
    styleUrl: './discount-card-selection.component.scss'
})
export class DiscountCardSelectionComponent implements OnInit {
  private formService = inject(FormService);

  @Input({required: true}) formGroup: FormGroup;

  discountCards = this.formService.discountCards;

  ngOnInit() {
    if (this.formService.form().previousSameRental) {
      this.formGroup.addControl('discountCard', new FormControl(this.formService.form().discountCard));
    } else {
      this.formGroup.addControl('discountCard', new FormControl(null));
      this.formService.fetchDiscountCards().subscribe({
        next: (discountCards: any) => this.formService.discountCards.update(() => discountCards),
        error: (error) => console.warn('Unable to retrieve discount cards', error),
      });
    }
  }

}
